import React from 'react';
import { Badge } from '@material-ui/core';
import ChatIcon from '@material-ui/icons/Chat';
import { useQuery, useSubscription } from '@apollo/react-hooks';
import {
  GetChatUnreadConversationsQuery,
  SubscriptionChatEventsSubscription,
} from 'types.d';
import { GET_CHAT_UNREAD_CONVERSATIONS, SUBSCRIPTION_CHAT_EVENTS } from 'gql';

/** Sidebar icon for Messages, with the number of unread conversations */
export const MessagesMenuIcon: React.FC = () => {
  const { data, refetch } = useQuery<GetChatUnreadConversationsQuery>(
    GET_CHAT_UNREAD_CONVERSATIONS,
    { fetchPolicy: 'network-only' },
  );

  useSubscription<SubscriptionChatEventsSubscription>(
    SUBSCRIPTION_CHAT_EVENTS,
    { onSubscriptionData: () => refetch() },
  );

  const count = data?.chatUnreadConversations || 0;

  return (
    <Badge badgeContent={count} color="secondary" invisible={!count}>
      <ChatIcon />
    </Badge>
  );
};

export default MessagesMenuIcon;
